import script from "./RecommendedActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedActivity.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedActivity.vue?vue&type=style&index=0&id=75fd1645&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fd1645"]])

export default __exports__